export default __webpack_public_path__ + "static/media/SaaSProductLandingPage.557f15c1.jpeg";